document.addEventListener('DOMContentLoaded',function(e){
    let accountTabs = document.querySelectorAll('.woocommerce .switch-tab');
    if(accountTabs){
        for(tab of accountTabs){
            tab.addEventListener('click', e => {
                let target = e.currentTarget.dataset.destination

                let targetElement = document.querySelector(`#${target}`)
                let previousActive = document.querySelector('.tab.active')
                let previousForm = document.querySelector('.form-content:not(.disabled)')

                previousActive.classList.toggle('active');
                e.currentTarget.closest('.tab').classList.toggle('active')

                targetElement.classList.toggle('disabled')
                previousForm.classList.toggle('disabled')
            })
        }
    }
})